import React, { Component } from "react";

import { withDevices } from "../../../shared/containers/containerDevices";
import { DataGrid } from "@mui/x-data-grid";
import Radio from "@mui/material/Radio";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HistoryIcon from "@mui/icons-material/History";
import styles from "./cmsDevices.module.scss";
import "./cellTable.css";
import Preloader from "../../../shared/items/static/preloader";
import { states } from "../../../reducers/queriesStates";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

class CmsDevicesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectDeviceId: null,
    };
  }

  componentDidMount() {
    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.NOT_REQUESTED) {
      onGetProtocolMarkers();
    }
  }

  componentWillUnmount() {
    const { onClearDevices } = this.props;
    onClearDevices();
  }

  getColumns() {
    const { onViewHistoryDevice, onViewHistoryUnit, protocolMarkers } = this.props;

    const renderTypeCell = (params) => {
      return protocolMarkers === null ? "" : protocolMarkers.protocolMarkers.filter((x) => x.value === params.row.type)[0].title;
    };

    const renderImeiCell = (params) => {
      const { onViewDevicePanel } = this.props;

      const type = renderTypeCell(params);
      return (
        <div style={{ display: "flex", fontSize: "11px", alignItems: "center" }}>
          <div
            onClick={() => {
              onViewHistoryDevice(params.row.id, params.row.imei, renderTypeCell(params));
            }}
          >
            <TooltipWrapper title={`Открыть панель истории ${params.value} ${type}`} position="top">
              <div className={"activetyHover"}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>

          <TooltipWrapper title={`Открыть панель настроек устройства ${params.value} ${type}`} position="top">
            <div
              className={"activetyHover"}
              onClick={() => {
                onViewDevicePanel(params.row.id);
              }}
            >
              {params.value}
            </div>
          </TooltipWrapper>
        </div>
      );
    };

    const renderRegisterNumberCell = (params) => {
      return (
        <div style={{ display: "flex", fontSize: "11px", alignItems: "center" }}>
          <div
            onClick={() => {
              onViewHistoryUnit(params.row.unitId, params.row.unitTitle, params.row.registerNumber);
            }}
          >
            <TooltipWrapper title={`Открыть панель истории ${params.row.unitTitle} ${params.row.registerNumber}`} position="top">
              <div className={"activetyHover"}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>

          <TooltipWrapper title={`Открыть панель действий с ${params.row.unitTitle} ${params.row.registerNumber}`} position="top">
            <div className={"activetyHover"}>
              <a href={`/cms/companies/${params.row.companyId}?unitId=${params.row.unitId}`} target="_blank" rel="noreferrer">
                {params.row.registerNumber}
              </a>
            </div>
          </TooltipWrapper>
        </div>
      );
    };

    const getRadioColumn = () => {
      const { selectedDevice, onSelectDevice, devices } = this.props;

      return [
        {
          field: "radiobutton",
          headerName: "",
          width: 60,
          sortable: false,
          renderCell: (params) => (
            <Radio
              checked={selectedDevice === null ? null : selectedDevice.id === params.id}
              value={params.id}
              onChange={(e) => {
                this.setState({ selectDeviceId: params.id });
                onSelectDevice(
                  devices.filter((x) => {
                    return x.id === params.id;
                  })[0]
                );
              }}
            />
          ),
        },
      ];
    };

    const renderCompanyTitleCell = (params) => {
      const { onViewHistoryCompany } = this.props;
      return (
        <div style={{ display: "flex", fontSize: "11px", alignItems: "center" }}>
          <div
            onClick={() => {
              onViewHistoryCompany(params.row.companyId, params.row.companyTitle);
            }}
          >
            <TooltipWrapper title={`Открыть панель истории ${params.row.companyTitle}`} position="top">
              <div className={"activetyHover"}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>

          <TooltipWrapper title={`Открыть панель действий с ${params.row.companyTitle}`} position="top">
            <div className={"activetyHover"}>
              <a href={`/cms/companies/${params.row.companyId}`} target="_blank" rel="noreferrer">
                {params.row.companyTitle}
              </a>
            </div>
          </TooltipWrapper>
        </div>
      );
    };

    const columns = [
      {
        field: "imei",
        headerName: "IMEI",
        renderCell: renderImeiCell,
        width: 150,
      },
      {
        field: "dateCreation",
        headerName: "Создан",
        type: "date",
        width: 100,
      },
      {
        field: "numberSim",
        headerName: "Номер SIM",
        width: 230,
      },
      {
        field: "phone",
        headerName: "Телефон",
        width: 180,
      },
      {
        field: "type",
        headerName: "Марка устройства",
        width: 150,
        renderCell: renderTypeCell,
      },
      {
        field: "title",
        headerName: "Подпись",
        width: 180,
      },
      {
        field: "registerNumber",
        headerName: "Регистрационный номер ",
        renderCell: renderRegisterNumberCell,
        width: 200,
      },
      {
        field: "companyTitle",
        headerName: "Компания",
        renderCell: renderCompanyTitleCell,
        width: 300,
      },
    ];

    const { isTransering } = this.props;

    return isTransering ? getRadioColumn().concat(columns) : columns;
  }

  getRows() {
    const { devices, currentDevice } = this.props;

    return devices
      .filter((x) => {
        return currentDevice === null || currentDevice.id !== x.id;
      })
      .map((device) => {
        return {
          ...device.unit,
          ...device,
          dateCreation: new Date(Date.parse(device.dateCreation)),
          unitId: device.unit.id,
          unitTitle: device.unit.title,
          companyId: device.company.id,
          companyTitle: device.company.title,
        };
      });
  }

  render() {
    const { devices, dataStateDevices } = this.props;

    if (dataStateDevices === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    if (devices.length === 0) {
      return null;
    }

    return (
      <div className={styles.cmsDevicesTableContainer}>
        <div className={styles.cmsDeviceble} style={{ height: "500px" }}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            disableColumnSelector={true}
            disableColumnFilter={true}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
}

export default withCurrentDevices(withDevices(CmsDevicesTable));
